module.exports = __webpack_public_path__ + "img/sof-logo.36c6045b.png";